import axios from 'axios';

const createNewStoreApi = async (values, token, langIsoCode, edit = false) => {
  const url = !edit ? '/Store/create' : '/Store/edit';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default createNewStoreApi;
